// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutNContact_container__1Z5Dl","title":"AboutNContact_title__3wRO0","text":"AboutNContact_text__259Ci"};